import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@gravity-ui/uikit';

import { APP_ELEMENT_ID } from 'features/app';
import { setupStore } from 'store/store';
import { RoutesApp } from 'routes';

import reportWebVitals from './reportWebVitals';

import '../src/assets/styles/index.scss';

const store = setupStore();

const root = createRoot(document.getElementById(APP_ELEMENT_ID) as HTMLElement);

root.render(
	<BrowserRouter>
		<Provider store={store}>
			<ThemeProvider theme="light">
				<RoutesApp />
			</ThemeProvider>
		</Provider>
	</BrowserRouter>,
);

reportWebVitals();
